import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $incomeByMonth,
  incomeByMonthListMounted,
  getIncomeByMonth,
} from './model'

export const useKPIList = () => {
  React.useEffect(() => {
    incomeByMonthListMounted()
  }, [])

  const incomeByMonth = useStore($incomeByMonth)
  const loading = useStore(getIncomeByMonth.pending)
  return {
    incomeByMonth,
    loading,
  }
}
